// extracted by mini-css-extract-plugin
export var additionalImage = "beer-module--additional-image--865cb";
export var descriptionText = "beer-module--description-text--801a4";
export var didYouKnow = "beer-module--did-you-know--c3ecb";
export var finderButton = "beer-module--finder-button--422cb";
export var nav = "beer-module--nav--6824b";
export var navbar = "beer-module--navbar--6c2bf";
export var productHeading = "beer-module--product-heading--4b911";
export var productImage = "beer-module--product-image--9b588";
export var productSubheading = "beer-module--product-subheading--fe254";
export var seasonal = "beer-module--seasonal--3f19d";
export var seasonalContent = "beer-module--seasonal-content--a4578";
export var section = "beer-module--section--7c0e7";